export enum ManageRespondentDropdownStates {
  initial = 0,
  moveTo = 1,
}
